import Loading from '../../../../../components/general/loadings/loading';
import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { useAlertsStatus } from './hook';
import { AlertsStatusProps } from './props';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import { Accordion } from '../../../../../components/general/accordion';

export const AlertsStatus = ({ alertStatus, loading }: AlertsStatusProps) => {
    const { formik } = useAlertsStatus(alertStatus);

    return loading ? (
        <Loading />
    ) : (
        <Accordion
            title="ESTADO ALERTA"
            icon={<SpeakerNotesIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={true}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="Nombre"
                        name="nameAlert"
                        size="small"
                        value={formik.values.nameAlert}
                        onChange={console.log}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="Nuevo Estado PQR"
                        name="newPqrStatus"
                        size="small"
                        value={formik.values.newPqrStatus}
                        onChange={console.log}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FieldText
                        label="Observación"
                        name="observation"
                        size="small"
                        rows={2}
                        value={formik.values.observation}
                        onChange={console.log}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
